module.exports = __webpack_public_path__ + "img/b001.5e64c62a.jpg";